import { render, staticRenderFns } from "./CrossApproveModal.vue?vue&type=template&id=65ddaefd"
import script from "./CrossApproveModal.vue?vue&type=script&lang=js"
export * from "./CrossApproveModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports